import React, {useState} from 'react';
import { connect } from 'react-redux';
import {showLoader} from "../../utils";
import {getIsFormValidating, getIsLoadingPasswordCheck, getPassword, getPasswordStatus,} from "../../selectors";
import {changePassword,} from "../../reducers";

const stateToProps = state => ({
    passwordStatus: getPasswordStatus(state),
    isLoadingPasswordCheck: getIsLoadingPasswordCheck(state),
    isFormValidating: getIsFormValidating(state),
    password: getPassword(state),
});

const actionsToProps = dispatch => ({
    changePassword: payload => dispatch(changePassword(payload)),
});

const Password = props => {

    const [showPassword, setShowPassword] = useState(false);


    return (
        <div className={`form-row ${props.passwordStatus}`}>
            <label className="form-label" htmlFor="password">
                {props.isLoadingPasswordCheck && showLoader()}
                Password <span className="asterisk">*</span>
            </label>

            <div className={`reg-form__pass ${showPassword ? '' : 'reg-form__pass--vision'}`}>
                <input type={showPassword ? 'text' : 'password'} className="form-input" id="password"
                       disabled={props.isFormValidating}
                       onBlur={() => props.checkPasswordAndValidateForm('password')} value={props.password}
                       onChange={e => props.changePassword({
                           password: e.target.value,
                           passwordStatus: 'none',
                           passwordErrorMessage: '',
                       })}
                />
                <span className="reg-form__pass-vision" onClick={() => setShowPassword(!showPassword)} />
            </div>

            <i className="form-status" />
            <p className={`callout p10 txt-l${props.passwordStatus}`}>
                Enter a password of your choice (min. 8 characters and max. 100).
                You must use letters and numbers. You may include special characters.
                Spaces are not permitted.
                Your password should not contain your name, surname, username or date of birth.
            </p>
        </div>
    );
}

export default connect(
    stateToProps,
    actionsToProps
)(Password);
